module.exports = __webpack_public_path__ + "static/media/14.c6b42609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/14.jpg
// module id = 383
// module chunks = 0